<template>
  <span
    :class="[
      'm-switch',
      'm-switch-' + type,
      {
        active: booleanVal,
        'is-disabled': disabled,
        'is-small': small
      }
    ]"
    @touchend.prevent="change"
    @mouseup.prevent="change"
  ></span>
</template>

<script>
export default {
  name: 'switchBtn',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: [Boolean, Number, String],
      default: false
    },
    disabled: Boolean,
    type: {
      type: String, // 颜色类型，可选['primary', 'minor', 'wanr'， 'danger']
      default: 'primary'
    },
    // pid: [String, Number],
    small: Boolean // 是否小开关
  },
  computed: {
    booleanVal () {
      return Boolean(Number(this.value));
    }
  },
  methods: {
    change () {
      if (!this.disabled) {
        let status = 0;
        if(this.value == 0){
          status = 1
        }
        this.$emit('change', !this.value)
        this.$emit('switch', {
          status: status,
          // id: this.pid
        })
      }
    }
  }
}
</script>

<style scoped lang='less'>
.m-switch {
  position: relative;
  display: inline-block;
  width: 54px;
  height: 30px;
  background-color: #d9d9d9;
  border-radius: 30px;
  transition: background-color .1s linear;
  -webkit-transition:  background-color .1s linear;
  -moz-transition:  background-color .1s linear;
  -o-transition:  background-color .1s linear;
}

.m-switch::after {
  content: '';
  position: absolute;
  left: 2px;
  top: 2px;
  display: block;
  width: 26px;
  height: 26px;
  background-color: white;
  border-radius: 50%;

  box-shadow: 0 3px 5px rgba(0,0,0,.3);

  transition: left .1s linear;
  -webkit-transition: left .1s linear;
  -moz-transition: left .1s linear;
  -o-transition: left .1s linear;
}

.m-switch.active { background-color: #9D6C29; }
.m-switch.active:after { left: 26px; }

.m-switch-primary.active { background-color: #9D6C29; }
.m-switch-minor.active { background-color: #a0d911; }
.m-switch-warn.active { background-color: #faad14; }
.m-switch-danger.active { background-color: #f5222d; }

.m-switch.is-small {
  width: 36px;
  height: 20px;
  border-radius: 20px;
}

.m-switch.is-small::after {
  width: 16px;
  height: 16px;
  box-shadow: 0 2px 3px rgba(0,0,0,.3);
}

.m-switch.is-small.active::after { left: 18px; }

.m-switch.is-disabled { opacity: .4; }
</style>
